import { generateHTML } from '@tiptap/html';
import { createExtensions } from "./extension-list.js";
export const renderHtml = model => {
  const extensions = createExtensions();
  return generateHTML(model, extensions);
};
//# sourceMappingURL=utils.js.map